import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { getDevice, isMobile } from '../../../../mobile/helpers';
import styles from './flash.scss';

const propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  persist: PropTypes.bool,
  bottom: PropTypes.bool,
  onClose: PropTypes.func,
};

class Flash extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      title: undefined,
      message: undefined,
      display: false,
      error: undefined,
      neutral: undefined,
    };
    this.delayHide = null;
    this.delayClear = null;
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { message } = newProps;
    const { message: oldMessage } = this.props;

    if (message !== oldMessage && typeof (message) !== 'undefined' && message !== false) {
      this.showFlash(newProps);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.delayHide);
    clearTimeout(this.delayClear);
  }

  showFlash = (newProps) => {
    // const { error } = this.state;
    const { persist } = this.props;

    this.setState({
      visible: true,
      display: true,
      ...newProps,
    }, () => {
      clearTimeout(this.delayHide);
      clearTimeout(this.delayClear);

      if (!persist) {
        this.delayHide = setTimeout(() => (
          this.hideFlash()
        ), 3000);
      }
    });
  }

  hideFlash = () => {
    const { onClose } = this.props;

    this.setState({
      visible: false,
    }, () => {
      if (onClose) {
        onClose();
      }
      this.delayClear = setTimeout(() => (
        this.setState({
          message: undefined,
          display: false,
        })
      ), 300);
    });
  }

  render() {
    const {
      visible,
      message,
      display,
      title,
      error,
      neutral,
    } = this.state;
    const { bottom } = this.props;

    return (
      <div className={classNames(
        styles.flash,
        {
          [styles.bottom]: bottom,
          [styles.visible]: visible,
          [styles.display]: display,
          [styles.error]: error,
          [styles.neutral]: neutral,
          [styles.ios]: isMobile() && getDevice() === 'iOS',
        },
      )}
      >
        <div className={styles.padding}>
          <div className={styles.content}>
            <div className={styles.title}>
              {title}
            </div>
            <div className={styles.message}>{message?.message || message}</div>
          </div>
          <div
            className={styles.close}
            role="button"
            tabIndex={0}
            onClick={() => this.hideFlash()}
          >
            <i className="far fa-times" />
          </div>
        </div>
      </div>
    );
  }
}

Flash.propTypes = propTypes;

export default Flash;
